import { ContactUsModel } from './../../interfaces/ContactUs.model';
import { useMutation } from '@tanstack/react-query';
import { contactUs } from '../mutations/contactUs';

export const useContactUsFormMutation = () => {
  return useMutation(['contact-us-form'], (data: ContactUsModel) =>
    contactUs(data)
  );
};
